module.exports = __webpack_public_path__ + "img/primary_4x1_z16.3313bf72.svg";